export const SET = 'BsxPrinterAuths/SET';

export function setBsxPrinterAuths(bsxPrinterAuths) {
  return {
    type: SET,
    bsxPrinterAuths
  }
}